import { ArrowUpRight } from "lucide-react";
import { useActiveAds, bannerAd } from "@/lib/ads";

// A single exclusive text-ad slot on the homepage, between the planner and the FAQ.
// When sold, it shows the advertiser's text (name links to their site). When open,
// it shows a "This space could be yours" placeholder linking to /advertise.
export const HomeTextAd = () => {
  const ad = bannerAd(useActiveAds());

  if (ad) {
    return (
      <section data-testid="home-text-ad" className="bg-[#F9F8F6] py-10 md:py-14">
        <div className="max-w-[1000px] mx-auto px-5 md:px-10">
          <div className="bg-white border border-zinc-200 shadow-brut rounded-2xl p-6 md:p-8 flex flex-col md:flex-row md:items-center gap-4 md:gap-8">
            <span className="font-body font-800 text-[10px] tracking-[0.3em] eyebrow text-black/35 shrink-0">
              SPONSORED
            </span>
            <div className="flex-1 min-w-0">
              {ad.website ? (
                <a
                  href={ad.website}
                  target="_blank"
                  rel="noopener noreferrer nofollow sponsored"
                  data-testid="home-text-ad-link"
                  className="font-display font-900 tracking-tight text-2xl md:text-3xl inline-flex items-center gap-1.5 text-[#DF3226] hover:text-[#DF3226] transition-colors"
                >
                  {ad.business_name}
                  <ArrowUpRight size={22} className="shrink-0" />
                </a>
              ) : (
                <h3 className="font-display font-900 tracking-tight text-2xl md:text-3xl">
                  {ad.business_name}
                </h3>
              )}
              <p className="font-body text-base text-black/70 mt-1.5 leading-relaxed">
                {ad.description}
              </p>
            </div>
          </div>
        </div>
      </section>
    );
  }

  // No active banner → render nothing (the slot is sold on /advertise).
  return null;
};
